import React from "react";
import {
  Calendar,
  Phone,
  HeartPulse,
  Brain,
  Bone,
  Baby,
  User,          // <-- Correct replacement
  Stethoscope,
  Pill,
  Ear,
  ChevronRight,
  MessageSquare,
  Scissors,
  Activity,
  Droplet,
  Wind,
  Scan,
  Dumbbell,
  Layers,
  Syringe,
  Beaker,
  Apple,
  Heart,
  Bike,
  Smile,
  Radio
} from "lucide-react";

import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { HeaderNav } from "../components/header-nav";
import { Badge } from "../components/ui/badge";
import SEO from "./SEO";

const departments = [
  {
    name: "Cardiology",
    icon: HeartPulse,
    description: "Comprehensive heart care with advanced diagnostic and treatment options for all cardiac conditions.",
    services: ["Interventional Cardiology", "Cardiac Rehabilitation", "Heart Rhythm Management"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/11/jpeg-optimizer_closeup-heart-stethoscope-cardiovascular-checkup-concept-scaled.jpg",
  },
  {
    name: "Neurology",
    icon: Brain,
    description:
      "Expert care for conditions affecting the brain, spine, and nervous system with advanced diagnostic capabilities.",
    services: ["Stroke Management", "Epilepsy Treatment", "Movement Disorders"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_dementia-parkinson-s-disease-adhd-composition-head-disease-theme-1.jpg",
  },
  {
    name: "Orthopedics",
    icon: Bone,
    description:
      "Specialized treatment for bone, joint, and muscle conditions with a focus on restoring mobility and function.",
    services: ["Joint Replacement", "Sports Medicine", "Spine Surgery"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/11/jpeg-optimizer_front-view-doctor-explaining-anatomy-scaled.jpg",
  },
  {
    name: "Paediatric",
    icon: Baby,
    description:
      "Compassionate healthcare for infants, children, and adolescents with a focus on growth and development.",
    services: ["Neonatal Care", "Pediatric Immunizations", "Developmental Assessments"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_portrait-female-pediatrician-work-1.jpg",
  },
  {
    name: "Paediatric Surgery",
    icon: Scissors,
    description:
      "Specialized surgical care for infants, children, and adolescents with expertise in pediatric conditions.",
    services: ["Congenital Defects Surgery", "Pediatric Trauma", "Minimally Invasive Procedures"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_close-up-baby-boy-being-examined.jpg",
  },
  {
  name: "Gynaecology",
  icon: User,
  description: "Comprehensive women's health services from routine care to specialized treatments for all stages of life.",
  services: ["Obstetrics & Maternity", "Gynecological Surgery", "Fertility Services"],
  image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_doctor-holding-anatomic-model-high-angle-scaled.jpg",
},
  {
    name: "Dentistry",
    icon: Smile,
    description: "Complete dental care services including preventive, restorative, and cosmetic dentistry.",
    services: ["Dental Implants", "Root Canal Treatment", "Orthodontics"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_dentists-treat-patients-teeth-1-scaled.jpg",
  },
  {
    name: "Gastroenterology",
    icon: Droplet,
    description:
      "Specialized care for digestive system disorders including liver, pancreas, and gastrointestinal conditions.",
    services: ["Endoscopy", "Liver Disease Treatment", "Inflammatory Bowel Disease"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_5adba3d9-a841-4276-a938-13c23cb02dda-scaled.jpg",
  },
  {
    name: "General Surgery",
    icon: Scissors,
    description:
      "Expert surgical care for a wide range of conditions with minimally invasive techniques and advanced technology.",
    services: ["Emergency Surgery", "Hernia Repair", "Appendectomy"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_doctors-doing-surgical-procedure-patient.jpg",
  },
  {
    name: "General Medicine",
    icon: Pill,
    description:
      "Comprehensive medical care for adults with a focus on prevention, diagnosis, and treatment of diseases.",
    services: ["Preventive Health Checkups", "Chronic Disease Management", "Internal Medicine"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_stethoscope-white-background-with-mix-pills-isolated-scaled.jpg",
  },
  {
    name: "Neonatology",
    icon: Baby,
    description:
      "Specialized care for newborn infants, particularly premature or critically ill babies requiring intensive support.",
    services: ["NICU Care", "Premature Baby Care", "Neonatal Surgery Support"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_newborn-baby-with-parents.jpg",
  },
  {
    name: "Prenatal Yoga",
    icon: Bike,
    description:
      "Specialized yoga programs designed for pregnant women to promote wellness and prepare for childbirth.",
    services: ["Pregnancy Fitness", "Breathing Techniques", "Stress Management"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_pregnant-woman-meditate-yoga-mat-scaled.jpg",
  },
  {
    name: "Critical Care",
    icon: Activity,
    description:
      "Advanced life support and monitoring for critically ill patients with 24/7 specialized intensive care.",
    services: ["Ventilator Support", "Hemodynamic Monitoring", "Post-Surgical Care"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_empty-hospital-ward-with-heart-rate-monitor-bed-healthcare-recovery-nobody-emergency-room-with-medical-equipment-intensive-care-patient-reanimation-room-with-tools-scaled.jpg",
  },
  {
    name: "Pathology",
    icon: Beaker,
    description: "Comprehensive laboratory services for accurate diagnosis through advanced testing and analysis.",
    services: ["Blood Tests", "Tissue Analysis", "Molecular Diagnostics"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_microscope-close-up-specimen-tray-lab-studied-by-expert-optical-instrument-lens-system.jpg",
  },
  {
    name: "Neurosurgery",
    icon: Brain,
    description:
      "Advanced surgical treatments for brain, spine, and nervous system conditions with cutting-edge technology.",
    services: ["Brain Surgery", "Spine Surgery", "Neuro-oncology"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_using-cut-out-lifestyle-urban-uniform-scaled.jpg",
  },
  {
    name: "Oncology",
    icon: Heart,
    description:
      "Comprehensive cancer care with advanced treatment options including chemotherapy and radiation therapy.",
    services: ["Cancer Diagnosis", "Chemotherapy", "Radiation Therapy"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_893938559046-scaled.jpg",
  },
  {
    name: "Urology & Nephrology",
    icon: Droplet,
    description:
      "Specialized care for urinary tract and kidney disorders with advanced diagnostic and treatment options.",
    services: ["Kidney Stone Treatment", "Dialysis", "Urological Surgery"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_JEMA-GER-1430-20-scaled.jpg",
  },
  {
    name: "Laparoscopic Surgery",
    icon: Layers,
    description: "Minimally invasive surgical procedures with faster recovery times and reduced complications.",
    services: ["Laparoscopic Cholecystectomy", "Bariatric Surgery", "Hernia Repair"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_doctors-doing-surgical-procedure-patient-1.jpg",
  },
  {
    name: "Physiotherapy",
    icon: Dumbbell,
    description:
      "Comprehensive rehabilitation services to restore mobility, function, and quality of life after injury or illness.",
    services: ["Physical Therapy", "Sports Rehabilitation", "Post-Surgical Rehabilitation"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_young-latin-woman-wearing-physiotherapist-uniform-holding-anatomical-model-vertebral-column-physiotherapy-clinic-scaled.jpg",
  },
  {
    name: "Dietetics",
    icon: Apple,
    description: "Expert nutritional counseling and diet planning for various health conditions and wellness goals.",
    services: ["Nutrition Counseling", "Weight Management", "Therapeutic Diets"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_woman-writing-blurred-fruit.jpg",
  },
  {
    name: "Dermatology",
    icon: Scan,
    description:
      "Comprehensive skin care services for medical and cosmetic dermatology needs with advanced treatments.",
    services: ["Skin Disease Treatment", "Cosmetic Dermatology", "Laser Treatments"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_skin-allergy-person-s-arm-scaled.jpg",
  },
  {
    name: "ENT",
    icon: Ear,
    description: "Specialized care for conditions affecting the ear, nose, throat, head, and neck regions.",
    services: ["Sinus Disorders", "Hearing Loss Treatment", "Voice & Swallowing Disorders"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_close-up-physician-using-otoscope-ear-consultation-with-patient-woman-otologist-checking-infection-with-otolaryngology-instrument-medical-visit-coronavirus-pandemic.jpg",
  },
  {
    name: "Endocrinology",
    icon: Syringe,
    description: "Expert care for hormonal disorders including diabetes, thyroid conditions, and metabolic diseases.",
    services: ["Diabetes Management", "Thyroid Treatment", "Hormone Therapy"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_x-ray-with-neon-colors.jpg",
  },
  {
    name: "Pulmonology",
    icon: Wind,
    description: "Expert care for respiratory and lung conditions with advanced diagnostic and therapeutic services.",
    services: ["Asthma Management", "COPD Treatment", "Sleep Disorders"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_images-that-simulate-x-rays-with-neon-colors.jpg",
  },
  {
    name: "Plastic & Cosmetic Surgery",
    icon: Scissors,
    description: "Specialized surgical procedures for reconstruction, aesthetic enhancement, and trauma repair.",
    services: ["Reconstructive Surgery", "Cosmetic Surgery", "Burn Treatment"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_woman-with-marks-skin-has-injection-eyelid-undergoes-plastic-surgery-debrides-dead-skin-scaled.jpg",
  },
  {
    name: "Psychology",
    icon: Brain,
    description:
      "Comprehensive mental health services including counseling, therapy, and psychiatric care for all ages.",
    services: ["Mental Health Counseling", "Psychiatric Treatment", "Behavioral Therapy"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_mental-health-care-sketch-diagram.jpg",
  },
  {
    name: "Radiology",
    icon: Radio,
    description: "Advanced imaging services for accurate diagnosis including X-ray, CT, MRI, and ultrasound.",
    services: ["X-Ray", "CT Scan", "MRI", "Ultrasound"],
    image: "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/12/jpeg-optimizer_logo_make_11_06_2023_359.jpg",
  },
];

export default function ServicesPage() {
  const servicesPageSchema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaam.pranaamhospitals.in/",
    "logo": "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/logo.png",
    "description": "Pranaam Hospitals is a NABH-accredited multi-specialty hospital in Hyderabad offering a comprehensive range of healthcare services.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "appointments",
        "telephone": "+91-99660-60000",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      },
      {
        "@type": "ContactPoint",
        "contactType": "emergency",
        "telephone": "+91-98485-98285",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Pranaam Hospitals Healthcare Services",
    "url": "https://pranaam.pranaamhospitals.in/services",
    "description": "Browse the wide range of healthcare services offered by Pranaam Hospitals in Hyderabad including specialties, diagnostics, emergency care, and more.",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Cardiology",
          "url": "https://pranaam.pranaamhospitals.in/services/cardiology"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Neurology",
          "url": "https://pranaam.pranaamhospitals.in/services/neurology"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Orthopedics",
          "url": "https://pranaam.pranaamhospitals.in/services/orthopedics"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Pediatrics",
          "url": "https://pranaam.pranaamhospitals.in/services/paediatric"
        },
        {
          "@type": "ListItem",
          "position": 5,
          "name": "General Medicine",
          "url": "https://pranaam.pranaamhospitals.in/services/general-medicine"
        },
        {
          "@type": "ListItem",
          "position": 6,
          "name": "Critical Care",
          "url": "https://pranaam.pranaamhospitals.in/services/critical-care"
        },
        {
          "@type": "ListItem",
          "position": 7,
          "name": "Diagnostics & Pathology",
          "url": "https://pranaam.pranaamhospitals.in/services/pathology"
        },
        {
          "@type": "ListItem",
          "position": 8,
          "name": "Physiotherapy",
          "url": "https://pranaam.pranaamhospitals.in/services/physiotherapy"
        }
        // Add remaining services if needed
      ]
    }
  }
];

  return (
    <>
    <SEO
      title="Our Healthcare Services in Hyderabad | Pranaam Hospitals"
      description="Explore the wide range of healthcare services offered by Pranaam Hospitals in Hyderabad, including cardiology, neurology, orthopedics, pediatrics, surgery, diagnostics, and more."
      canonical="https://pranaam.pranaamhospitals.in/services"
      robots="index, follow"
      author="Pranaam Hospitals"
      publisher="Pranaam Hospitals"
      keywords="Pranaam Hospitals services, healthcare services Hyderabad, multi-specialty hospital services, cardiology, neurology, orthopedics, pediatrics, diagnostics, general medicine, emergency care Hyderabad"
      schema={servicesPageSchema}
    />

    <div className="min-h-screen bg-white">
     <main>
        {/* HERO SECTION */}
        <section className="relative py-16 md:py-24 bg-gradient-to-r from-primary/10 to-primary/5">
          <div className="container px-4 mx-auto text-center">
            <Badge className="mb-4 px-3 py-1 bg-primary/10 text-primary border-primary/20">
              <Stethoscope className="w-4 h-4 mr-1" />
              Our Specialties
            </Badge>

            <h1 className="mb-4 text-4xl md:text-5xl lg:text-6xl font-bold font-heading">
              Comprehensive <span className="text-primary">Healthcare Services</span>
            </h1>

            <p className="mb-8 text-lg text-gray-700">
              At Pranaam Hospitals, we offer a wide range of specialized medical services across{" "}
              {departments.length}+ departments.
            </p>

             <Button size="lg" asChild>
                <a
                href="https://pranaamhospitals.com/apps/pranaam/patient/?routeName=doctors&refId=otp&visitType=T&treatmentType=1&deepLink=Y&consultType=001">
                <Calendar className="w-5 h-5" />
                Book an Appointment
              </a>
            </Button>
          </div>
        </section>

        {/* SERVICES GRID */}
        <section className="py-16 bg-white">
          <div className="container px-4 mx-auto">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {departments.map((dept, index) => {
                const IconComponent = dept.icon;

                return (
                  <Card key={index} className="overflow-hidden hover:shadow-lg transition-all group">
                    <div className="relative h-72">
                      <img
                        src={dept.image}
                        alt={dept.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />

                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6">
                        <div className="flex items-center gap-2">
                          <IconComponent className="w-5 h-5 text-white" />
                          <h3 className="text-xl font-bold text-white">{dept.name}</h3>
                        </div>
                      </div>
                    </div>

                    <CardContent className="p-6">
                      <p className="mb-4 text-gray-700">{dept.description}</p>

                      <ul className="mb-6 space-y-2">
                        {dept.services.map((service, idx) => (
                          <li key={idx} className="flex items-start gap-2">
                            <ChevronRight className="w-4 h-4 mt-1 text-primary" />
                            <span className="text-sm">{service}</span>
                          </li>
                        ))}
                      </ul>

                      <Button className="w-full gap-2">
                        <a
                          href={`/services/${dept.name.toLowerCase().replace(/\s+&?\s+/g, "-")}`}
                          className="flex items-center justify-center gap-2"
                        >
                          Learn More
                          <ChevronRight className="w-4 h-4" />
                        </a>
                      </Button>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>

        {/* WHY CHOOSE US */}
        <section className="py-16 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <Badge className="mb-4">Why Choose Us</Badge>

              <h2 className="text-3xl md:text-4xl font-bold font-heading mb-4">
                Excellence in <span className="text-primary">Every Department</span>
              </h2>

              <p className="text-gray-700">
                Our commitment to providing world-class healthcare across all specialties sets us apart.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
              <Card className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
                    <Stethoscope className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">Expert Specialists</h3>
                  <p className="text-sm text-gray-700">Highly qualified doctors with years of experience.</p>
                </CardContent>
              </Card>

              <Card className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
                    <Activity className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">Advanced Technology</h3>
                  <p className="text-sm text-gray-700">Cutting-edge diagnostic and treatment systems.</p>
                </CardContent>
              </Card>

              <Card className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
                    <HeartPulse className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">Patient-Centric Care</h3>
                  <p className="text-sm text-gray-700">Compassionate care focused on comfort and recovery.</p>
                </CardContent>
              </Card>

              <Card className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
                    <Calendar className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">24/7 Availability</h3>
                  <p className="text-sm text-gray-700">Emergency and critical care round the clock.</p>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="py-16 bg-white">
          <div className="container px-4 mx-auto">
            <Card className="shadow-xl">
              <div className="p-12 bg-gradient-to-r from-primary to-black text-center text-white">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 font-heading">Ready to Get Started?</h2>

                <p className="text-lg mb-8 opacity-90 max-w-xl mx-auto">
                  Book an appointment with our specialists and experience world-class healthcare.
                </p>

                <div className="flex flex-wrap justify-center gap-4">
                  <Button size="lg" variant="secondary" className="gap-2 shadow-md">
                    <a href="/book-appointment" className="flex items-center gap-2">
                      <Calendar className="w-5 h-5" />
                      Book Appointment
                    </a>
                  </Button>

                  <Button
                    size="lg"
                    variant="outline"
                    className="gap-2 bg-white/10 border-white text-white hover:bg-white hover:text-primary"
                  >
                    <a href="/contact">Contact Us</a>
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </section>
      </main>


      {/* WHATSAPP BUTTON */}
      {/* <div className="fixed bottom-6 right-6">
        <a
          href="https://wa.me/919848598285"
          className="w-14 h-14 bg-green-500 flex items-center justify-center rounded-full shadow-lg hover:bg-green-600"
        >
          <MessageSquare className="w-7 h-7 text-white" />
        </a>
      </div> */}
    </div>
    </>
  );
}
